import React from 'react';
import { FieldArray, useFormikContext } from 'formik';
import { Button } from 'primereact/button';
import SuperProfileRequiredLanguageProficiencyInput from './SuperProfileRequiredLanguageProficiencyInput';

const SuperProfileRequiredLanguageProficiencies = ({ availableLanguages }) => {
  const { values } = useFormikContext();

  return (
    <div className="p-col-12">
      <FieldArray
        name="requiredLanguageProficiencies"
        render={(arrayHelpers) => (
          <div>
            {values.requiredLanguageProficiencies && values.requiredLanguageProficiencies.length > 0 ? (
              values.requiredLanguageProficiencies.map((_languageProficiency, index) => (
                <div key={index} className="margin-bottom-1">
                  <SuperProfileRequiredLanguageProficiencyInput
                    index={index}
                    availableLanguages={availableLanguages}
                  />
                  <div className="flex justify-center gap-4 align-middle">
                    <Button
                      type="button"
                      icon="pi pi-minus"
                      className="p-button-primary"
                      onClick={() => arrayHelpers.remove(index)}
                    />
                    <Button
                      type="button"
                      icon="pi pi-plus"
                      className="p-button-primary"
                      onClick={() => arrayHelpers.insert(index + 1, '')}
                    />
                  </div>
                </div>
              ))
            ) : (
              <Button
                type="button"
                icon="pi pi-plus"
                className="p-button-primary"
                onClick={() => arrayHelpers.push('')}
              />
            )}
          </div>
        )}
      />
    </div>
  );
};

export default SuperProfileRequiredLanguageProficiencies;
